import { DatoImage } from '@components/image/DatoImage';
import { ImagesFragment } from '@graphql/generated';
import { useState } from 'react';
import { Autoplay, FreeMode, Navigation, Pagination, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

type Props = {
  images: ImagesFragment[];
};

export const ProductHero = ({ images }: Props) => {
  const hasGallery = images && images.length > 1;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <div className="product-hero__image">
      <div className="product-hero__image__gallery">
        <div className="swiper">
          <Swiper
            className="swiper-wrapper"
            modules={[Autoplay, Navigation, Pagination, FreeMode, Thumbs]}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
          >
            {images.map((image, index) => (
              <SwiperSlide className="swiper-slide" key={index}>
                <DatoImage data={image.responsiveImage} priority={index == 0} />
              </SwiperSlide>
            ))}
          </Swiper>
          {hasGallery && (
            <>
              <div className="swiper-button-prev" />
              <div className="swiper-button-next" />
            </>
          )}
        </div>

        {hasGallery && (
          <div className="product-hero__image__thumbs">
            <div className="swiper">
              <Swiper
                modules={[Thumbs, FreeMode]}
                spaceBetween={10}
                slidesPerView={4}
                freeMode={true}
                watchSlidesProgress={true}
                onSwiper={setThumbsSwiper}
                className="swiper-wrapper"
              >
                {images.map((image, index) => (
                  <SwiperSlide className="swiper-slide" key={`thumb-${index}`}>
                    <img src={image.thumb} alt={image.thumb} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
